export let deferredPrompt = null;

export const listenInstallPrompt = () => {
    window.addEventListener('beforeinstallprompt', event => {
        deferredPrompt = event;
    })
};

export const addToHomeScreen = () => {
    deferredPrompt.prompt();
    deferredPrompt.userChoice
        .then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the A2HS prompt');
            } else {
                console.log('User dismissed the A2HS prompt');
            }
            deferredPrompt = null;
        });
};



// WEBPACK FOOTER //
// ./src/homeScreen.js